<template>
    <div class="intermediate-container">
        <span
            role="button"
            @click="clicked(imageIndex)"
            class="pointer intermediate-item"
            :class="selected === imageIndex ? 'intermediate-item-selected' : ''"
            v-for="(image, imageIndex) in images"
            :key="imageIndex"
        >
            <component
                :selected="selected === imageIndex"
                :is="image"
                :width="adjustSize(width, imageIndex)"
                :height="adjustSize(height, imageIndex)"
            ></component>
        </span>
    </div>
</template>

<script>
import Image1 from "@/components/Lab/Intermediate/1";
import Image2 from "@/components/Lab/Intermediate/2";
import Image3 from "@/components/Lab/Intermediate/3";
import Image4 from "@/components/Lab/Intermediate/4";
import Image5 from "@/components/Lab/Intermediate/5";
import { labMixin } from "@/mixins/lab.js";

export default {
    name: "IntermediateSelect",
    mixins: [labMixin],
    components: {
        Image1,
        Image2,
        Image3,
        Image4,
        Image5
    },
    data() {
        return {
            numImages: 5
        };
    },
    computed: {},
    methods: {}
};
</script>

<style lang="scss">
svg {
    margin: 0;
}

.intermediate-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 10px 0;
}

.intermediate-item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    width: 50px;
    //border: 1px solid #e3ebf6;
    &-selected {
        border: 2px solid #99d1ff;
        background: #cce8ff;
    }
    &:hover {
        background: #e5f3ff;
    }
}

.inter-stroke {
    stroke: #c1c1c1;
    stroke-width: 4;
    stroke-miterlimit: 10;
}

.fill-black {
    fill: #0d1b2b;
}

.inter-fill {
    fill: #ffffff;
    stroke: #ccc;
    stroke-width: 2;
}

.inter-fill:hover {
    stroke: #f6c343;
    stroke-width: 2;
    /* zoom: 10; */
}

.inter-active {
    //stroke: red;
    stroke-dasharray: 0;
}
</style>
